import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";

import { authenticateHubspot, updateHubspot } from 'actions/integrations/hubspot';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import cx from 'classnames';
import _ from 'lodash';
import {
  Row,
  Col,
  Form,
  Button,
  Image,
  Dropdown
} from "react-bootstrap";

import styles from './hubspot.module.scss';

import buildUrl from 'build-url';

export const HubspotAuthentication = ({authenticated}) => {
  const dispatch = useDispatch();

  const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}`;

  function handleAuthenticate() {
    //Calculate Position  
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    const url = buildUrl(apiUrl, {
      path: `/api/1.0/integrations/hubspot/authorize`
    })

    var newWindow = window.open(url, `Authorize hubspot Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleAuthenticateEvent, false);
    return false;
  }

  function handleAuthenticateEvent(e) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'HUBSPOT_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;

      if (!error) {
        let request = {
          code: code
        }

        dispatch(authenticateHubspot(request, (integration) => {
          dispatch(activatingIntegrationSuccedded(integration));
        }));
      }

      deEventer(messageEvent, handleAuthenticateEvent, false);
    }
  }

  return (
    <div className={styles.hubspotConfig}>
        <h3 className={styles.configTitle}>Log in to your Hubspot account</h3>
        <span className={styles.configDescription}>Please provide a user account with global access</span>
        <Button variant='primary' className={styles.authButton} onClick={handleAuthenticate}>
          {authenticated &&
            'Authenticating...'
          }

          {!authenticated &&
            'Authenticate'
          }
        </Button>
    </div>
  )
}
